import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Star } from 'lucide-react';
export function ProductHeroSection() {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = ['https://cdn.magicpatterns.com/uploads/ue1UHvVFctLn5M4uHM6oFK/IMG_6383.png', 'https://cdn.magicpatterns.com/uploads/eBdirEmDm2gYo3UiDGb4a6/CloseUp.png'];
  const features = ['Complete system with enclosed system housing', 'Plug-and-play electric power', '75-foot hose with trigger-jet wand', 'Draws solution directly from container', 'Automatic 60 PSI shutoff', 'Built for professional remediation and disinfecting'];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-765">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-766">
        {/* Image Column */}
        <div className="flex flex-col gap-4" data-id="element-767">
          <div className="bg-gray-100 rounded-xl overflow-hidden aspect-square flex items-center justify-center border border-gray-200 relative" data-id="element-768">
            <img src={images[selectedImage]} alt="ForceX Complete Kit" className="w-full h-full object-contain p-4" data-id="element-769" />
            <div className="absolute top-6 right-6 bg-brand-yellow text-brand-dark font-bold px-4 py-2 rounded-full shadow-md flex items-center" data-id="element-770">
              <Star className="h-4 w-4 mr-2 fill-current" data-id="element-771" />
              Most Popular
            </div>
          </div>

          {/* Thumbnails */}
          <div className="grid grid-cols-4 gap-4" data-id="element-772">
            {images.map((img, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`bg-gray-50 rounded-lg overflow-hidden aspect-square border-2 transition-all ${selectedImage === index ? 'border-brand-yellow ring-2 ring-brand-yellow/20' : 'border-transparent hover:border-gray-300'}`} data-id="element-773">
                <img src={img} alt={`View ${index + 1}`} className="w-full h-full object-contain p-2" data-id="element-774" />
              </button>)}
          </div>
        </div>

        {/* Content Column */}
        <div data-id="element-775">
          <div className="mb-2" data-id="element-776">
            <span className="inline-block bg-brand-dark text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-777">
              Professional Choice
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-778">
            ForceX – Complete Kit
          </h1>
          <p className="text-xl text-brand-yellow font-bold mb-6" data-id="element-779">
            Out of the box. On the job. No compromises.
          </p>

          <div className="prose prose-lg text-gray-600 mb-8" data-id="element-780">
            <p data-id="element-781">
              The ForceX Complete Kit is a ready-to-work electric spraying
              system built for professional contractors tackling demanding
              environments. The included system housing eliminates pouring and
              reduces chemical exposure while maintaining fast setup and
              mobility.
            </p>
          </div>

          <div className="bg-brand-light p-6 rounded-lg mb-8 border border-gray-200" data-id="element-782">
            <h3 className="font-bold text-brand-dark mb-4 text-lg" data-id="element-783">
              Key Features
            </h3>
            <ul className="space-y-3" data-id="element-784">
              {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-785">
                  <Check className="h-5 w-5 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-786" />
                  <span className="text-gray-700" data-id="element-787">{feature}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-788">
            <div className="text-3xl font-bold text-brand-dark" data-id="element-789">$749.99</div>
            <Link to="/contact" className="flex-grow sm:flex-grow-0" data-id="element-790">
              <button className="w-full sm:w-auto inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-791">
                Buy Now
              </button>
            </Link>
          </div>
          <p className="mt-4 text-sm text-gray-500" data-id="element-792">
            *First-time purchaser discounts available. Contact us for bulk
            pricing.
          </p>
        </div>
      </div>
    </div>;
}